export const GET_POPULAR_REPOS = "GET_POPULAR_REPOS";
export const SET_STARRED_REPOS = "SET_STARRED_REPOS";
export const IS_LOADING = "IS_LOADING";
